import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ClassesEnum } from "@/ts/enums/ClassesEnum";
import { router } from "@inertiajs/react";
import { useAtom } from "jotai";

import { Flex, Image } from "@chakra-ui/react";

import imgSvg from "@assets/img/auth/existing-user.svg";

import { checkoutAtom } from "@atoms/checkoutAtom.ts";

import ContentLayout from "@layouts/ContentLayout";

import { Text } from "@components/Text";

const ExistingUserContainer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [checkout] = useAtom(checkoutAtom);

    return (
        <ContentLayout
            containerWidth={["95%", null, null, 750]}
            title={t(
                "checkout.existingUserPage.title",
                "This email belongs to an existing Euka account"
            )}
            footerActionsProps={{
                canGoNext: true,
                nextBtnText: "Continue to login",
                onGoNext: () => router.get("/login"),
                onGoBack: () => navigate("/checkout"),
                btnClassHierarchy: {
                    next: [
                        ClassesEnum.ExistingUserContainer,
                        ClassesEnum.Button
                    ],
                    back: [
                        ClassesEnum.ExistingUserContainer,
                        ClassesEnum.Button
                    ]
                },
                btnActions: {
                    next: "goNextFromExistingUserPage",
                    back: "goBackFromExistingUserPage"
                }
            }}
            className={ClassesEnum.ExistingUserContainer}
        >
            <Flex direction="column" as="form" gap={10}>
                <Image
                    w={[100, null, 265]}
                    h={[20, null, 155]}
                    marginX="auto"
                    objectFit="contain"
                    src={imgSvg}
                    alt="Existing User Alt"
                    pointerEvents="none"
                    userSelect="none"
                />
                <Text
                    fontWeight="bold"
                    fontSize={18}
                    textAlign={["left", "center"]}
                >
                    Hi {checkout.user.firstName}, if you’d like to enrol a new
                    or an existing student, you can do that in your Parent
                    Portal
                </Text>
                <Text textAlign={["left", "center"]}>
                    If you'd like to purchase a program for a new student or
                    re-enrol an existing student, you can easily do so in the
                    'Manage Programs' section in your Parent Portal. To continue
                    as {checkout.user.firstName}, simply log in to your Parent
                    Portal using the link below.
                </Text>
            </Flex>
        </ContentLayout>
    );
};

export default ExistingUserContainer;
